define('components/videofactory/VideoFactory', [
    'components/videofactory/enum/EnumVideoType',
    'components/videofactory/models/HTMLVideoModel',
    'components/videofactory/models/MMMVideoModel',
    'components/videofactory/models/YoutubeVideoModel',
    'components/videofactory/views/HTMLVideoView',
    'components/videofactory/views/MMMVideoView',
    'components/videofactory/views/YoutubeVideoView',
], function( EnumVideoType, HTMLVideoModel, MMMVideoModel, YoutubeVideoModel, HTMLVideoView, MMMVideoView, YoutubeVideoView ){

    var createModelFromData = function(data) {
        if (!_.isString(data.type) || !_.isString(data.viewId)) {
            return;
        }

        var _model = null;
        var obj = {};

        switch (data.type) {
            case EnumVideoType.HTML_VIDEO:
                obj = data;
                _model = new HTMLVideoModel(obj);
                break;

            case EnumVideoType.MMM_VIDEO:
                obj = data;
                _model = new MMMVideoModel(obj);
                break;

            case EnumVideoType.YOUTUBE_VIDEO:
                obj = data;
                _model = new YoutubeVideoModel(obj);
                break;

            default:
                break;
        }

        if (_.isNull(_model)) {
            console.warn("[VideoFactory -> createModelFromData] Can't create model of this type", data.type);
        }

        return _model;
    };

    var createViewFromModel = function(_model) {
        if (_.isNull(_model) || !_.isString(_model.get('type')) || !_.isString(_model.get('viewId'))) {
            return;
        }

        var _view = null;

        switch (_model.get('type')) {
            case EnumVideoType.HTML_VIDEO:
                _view = new HTMLVideoView({ "model": _model });
                break;

            case EnumVideoType.MMM_VIDEO:
                _view = new MMMVideoView({ "model" : _model });
                break;

            case EnumVideoType.YOUTUBE_VIDEO:
                _view = new YoutubeVideoView({ "model" : _model });
                break;

            default:
                break;
        }

        if (_.isNull(_view)) {
            console.warn("[Video Factory -> createViewFromModel] Can't create view of this type", _model.get('type'));
        }

        return _view;
    };

    return {
        createModelFromData: createModelFromData,
        createViewFromModel: createViewFromModel
    };
});
